import React from 'react';
import { useTranslation } from 'react-i18next';

const DocumentationSearch = (props) => {
    const { t } = useTranslation();
    const [searchVal, setSearchVal] = React.useState("");

    const pressEnter = (event) => {
        if (event.key === 'Enter') {
            document.getElementById('srcInput').blur();
            event.preventDefault();
        }
    };

    const resetSearch = () => {
        document.getElementById('srcInput').focus();
        setSearchVal("");
        props.data.setSearch(null)
        props.data.setContent(null)
    };

    const applySearch = () => {
        document.getElementById('srcInput').focus();
        props.data.setSearch(searchVal)
        props.data.setContent(null)
    };

    return (
        <form
            action="#"
            className={"search mb-4 mx-auto mx-md-0" + (props?.dark ? " bg-dark" : "")}
        >
            <input
                id="srcInput"
                type="text"
                value={searchVal}
                autoComplete="off"
                placeholder={t("placeholders.search")}
                className="search-input w-100 text-medium text-semibold pr-60 pl-40"
                onChange={(e) => {
                    setSearchVal(e.target.value);
                }}
                onKeyPress={(event) => {
                    pressEnter(event);
                }}
            />
            <span className="search-line d-block"></span>
            <div className="search-reset" onClick={() => { resetSearch(); }}></div>
            <span className="search-separator d-block"></span>
            <div className="search-apply" onClick={() => { applySearch(); }}></div>
        </form>
    )
}

export default DocumentationSearch;
